import eventApi from '../api/eventApi';
import clubDetail from '../models/clubDetail';
import clubEvents from '../models/clubEvents';
import clubPhotoDetail from '../models/clubPhotoDetail';
import clubSearch from '../models/clubSearch';
import eventBanner from '../models/eventBanner';
import eventDetail from '../models/eventDetail';
import eventSearch from '../models/eventSearch';
import eventUser from '../models/eventUser';
import timezone from '../models/timezone';
import { mappingVideoFile } from '../models/videoFile';
// @ts-ignore
import { IParamsRequest } from 'redhotpie-shared-lib/interfaces/IAction';
// @ts-ignore
import { IApiResponse } from 'redhotpie-shared-lib/interfaces/IApiResponse';
import User from '../models/user';

class EventService {
  getEventSearch(params: IParamsRequest): Promise<IApiResponse> {
    return eventApi
      .getEventSearch(params)
      .then(res => {
        if (res.success) {
          if (res.data) {
            return {
              success: res.success,
              data: {
                data: eventSearch.mappingObjectsCustomEventSearch(res.data.Data),
                total: res.data.Total,
              },
            };
          }
          return { success: res.success, data: { data: [], total: 0 } };
        }
        console.log('ERROR: eventService/getEventSearch:', res);
        return {
          success: res.success,
          data: { data: [], total: 0 },
          message: res.data.message,
        };
      })
      .catch(e => {
        console.warn('ERROR: eventService/getEventSearch:', e);
        return { success: false, data: { data: [], total: 0 }, message: e };
      });
  }

  getClubSearch(params: IParamsRequest): Promise<IApiResponse> {
    return eventApi
      .getClubSearch(params)
      .then(res => {
        if (res.success) {
          if (res.data) {
            return {
              success: res.success,
              data: {
                data: clubSearch.mappingObjects(res.data.Data),
                total: res.data.Total,
              },
            };
          }
          return { success: res.success, data: { data: [], total: 0 } };
        }
        console.log('ERROR: eventService/getClubSearch:', res);
        return {
          success: res.success,
          data: { data: [], total: 0 },
          message: res.data.message,
        };
      })
      .catch(e => {
        console.warn('ERROR: eventService/getClubSearch:', e);
        return { success: false, data: { data: [], total: 0 }, message: e };
      });
  }

  getDetailClub(params: IParamsRequest): Promise<IApiResponse> {
    return eventApi
      .getDetailClub(params)
      .then(res => {
        if (res.success) {
          if (res.data) {
            return { success: res.success, data: { data: clubDetail.mappingObject(res.data) } };
          }
          return { success: res.success, data: { data: [] } };
        }
        console.log('ERROR: eventService/getDetailClub:', res);
        return {
          success: res.success,
          data: { data: [] },
          message: res.data.message,
        };
      })
      .catch(e => {
        console.warn('ERROR: eventService/getDetailClub:', e);
        return { success: false, data: { data: [] }, message: e };
      });
  }

  getPhotoDetailClub(params: IParamsRequest): Promise<IApiResponse> {
    return eventApi
      .getPhotoDetailClub(params)
      .then(res => {
        if (res.success) {
          if (res.data && res.data.items) {
            return { success: res.success, data: { data: clubPhotoDetail.mappingObjects(res.data.items) } };
          }
          return { success: res.success, data: { data: [] } };
        }
        console.log('ERROR: eventService/getPhotoDetailClub:', res);
        return {
          success: res.success,
          data: { data: [] },
          message: res.data.message,
        };
      })
      .catch(e => {
        console.warn('ERROR: eventService/getPhotoDetailClub:', e);
        return { success: false, data: { data: [] }, message: e };
      });
  }

  getUserEvents(params: IParamsRequest): Promise<IApiResponse> {
    return eventApi
      .getUserEvents(params)
      .then(res => {
        if (res.success) {
          if (res.data) {
            console.log('res.data.items', res.data.items);
            return { success: res.success, data: eventUser.mappingObjectsCustomMember(res.data.items) };
          }
          return { success: res.success, data: [] };
        }
        console.log('ERROR: eventService/getUserEvents:', res);
        return res;
      })
      .catch(e => {
        console.warn('ERROR: eventService/getUserEvents:', e);
        throw new Error('failed');
      });
  }

  getEventOfUser(params: IParamsRequest): Promise<IApiResponse> {
    return eventApi
      .getEventOfUser(params)
      .then(res => {
        if (res.success) {
          if (res.data) {
            return { success: res.success, data: eventDetail.mappingEventUserDetail(res.data) };
          }
          return { success: res.success, data: [] };
        }
        console.log('ERROR: eventService/getEventOfUser:', res);
        return { success: res.success, data: [] };
      })
      .catch(e => {
        console.warn('ERROR: eventService/getEventOfUser:', e);
        throw new Error('failed');
      });
  }

  getUserEventInterest(params: IParamsRequest): Promise<IApiResponse> {
    return (
      eventApi
        // .getUserEventInterest(params) // DEPRECATED
        .getEventInterest(params)
        .then(res => {
          if (res.success) {
            if (res.data) {
              return { success: res.success, data: eventDetail.mappingObjectsEventInterest(res.data.Data) };
            }
            return { success: res.success, data: [] };
          }
          console.log('ERROR: eventService/getUserEventInterest:', res);
          return { success: res.success, data: [] };
        })
        .catch(e => {
          console.warn('ERROR: eventService/getUserEventInterest:', e);
          throw new Error('failed');
        })
    );
  }

  getEventInterest(params: IParamsRequest): Promise<IApiResponse> {
    return eventApi
      .getEventInterest(params)
      .then(res => {
        if (res.success) {
          if (res.data) {
            return {
              success: res.success,
              data: {
                data: eventDetail.mappingObjectsEventInterest(res.data.Data),
                total: res.data.Total,
              },
            };
          }
          return { success: res.success, data: { data: [], total: 0 } };
        }
        console.log('ERROR: eventService/getEventInterest:', res);
        return { success: res.success, data: { data: [], total: 0 } };
      })
      .catch(e => {
        console.warn('ERROR: eventService/getEventInterest:', e);
        throw new Error('failed');
      });
  }

  deleteEventInterest(id: string): Promise<IApiResponse> {
    return eventApi
      .deleteEventInterest(id)
      .then(res => {
        if (res.success) {
          if (res.data) {
            return { success: res.success };
          }
          return { success: res.success };
        }
        console.log('ERROR: eventService/deleteEventInterest:', res);
        return { success: res.success };
      })
      .catch(e => {
        console.warn('ERROR: eventService/deleteEventInterest:', e);
        throw new Error('failed');
      });
  }

  getEventComment(params: IParamsRequest): Promise<IApiResponse> {
    return eventApi
      .getEventComment(params)
      .then(res => {
        if (res.success) {
          if (res.data) {
            return { success: res.success, data: eventDetail.mappingObjectsEventComment(res.data) };
          }
          return { success: res.success, data: {} };
        }
        console.log('ERROR: eventService/getEventComment:', res);
        return { success: res.success, data: {} };
      })
      .catch(e => {
        console.warn('ERROR: eventService/getEventComment:', e);
        throw new Error('failed');
      });
  }

  getEventClub(params: IParamsRequest): Promise<IApiResponse> {
    return eventApi
      .getEventClub(params)
      .then(res => {
        if (res.success) {
          if (res.data) {
            return { success: res.success, data: res.data.items };
          }
          return { success: res.success, data: [] };
        }
        console.log('ERROR: eventService/getEventClub:', res);
        return res;
      })
      .catch(e => {
        console.warn('ERROR: eventService/getEventClub:', e);
        throw new Error('failed');
      });
  }

  getEventDetail(params: IParamsRequest): Promise<IApiResponse> {
    return eventApi
      .getEventDetail(params)
      .then(res => {
        if (res.success) {
          if (res.data) {
            return { success: res.success, data: eventDetail.mappingObject(res.data) };
          }
          return { success: res.success, data: [] };
        }
        console.log('ERROR: eventService/getEventDetail:', res);
        return { success: res.success, data: [] };
      })
      .catch(e => {
        console.warn('ERROR: eventService/getEventDetail:', e);
        throw new Error('failed');
      });
  }

  postCreateEvent(params: IParamsRequest, clubId?: any, additionalDateHelds?: string[]): Promise<IApiResponse> {
    return eventApi
      .postCreateEvent(params, clubId, additionalDateHelds)
      .then(res => {
        if (res.success) {
          if (res.data) {
            return { success: res.success, data: res.data };
          }
          return { success: res.success, data: [] };
        }
        console.log('ERROR: eventService/postCreateEvent:', res);
        let msg = 'Create event fail, please check it again.';
        if (res.data.message) {
          msg = res.data.message;
        } else if (res.message) {
          msg = res.message;
        }
        return {
          success: res.success,
          data: [],
          message: msg,
        };
      })
      .catch(e => {
        console.warn('ERROR: eventService/postCreateEvent:', e);
        throw new Error('failed');
      });
  }

  postCreateEventInterest(params: IParamsRequest): Promise<IApiResponse> {
    return eventApi
      .postCreateEventInterest(params)
      .then(res => {
        if (res.success) {
          if (res.data) {
            return { success: res.success, data: res.data.items ? res.data.items : res.data.Result };
          }
          return { success: res.success, data: [] };
        }
        console.log('ERROR: eventService/postCreateEventInterest:', res);
        return res;
      })
      .catch(e => {
        console.warn('ERROR: eventService/postCreateEventInterest:', e);
        throw new Error('failed');
      });
  }

  postCreateEventComment(body: any, params: IParamsRequest): Promise<IApiResponse> {
    return eventApi
      .postCreateEventComment(body, params)
      .then(res => {
        if (res.success) {
          if (res.data) {
            return { success: res.success, data: eventDetail.mappingObjectComment(res.data) };
          }
          return { success: res.success, data: [] };
        }
        console.log('ERROR: eventService/postCreateEventComment:', res);
        return res;
      })
      .catch(e => {
        console.warn('ERROR: eventService/postCreateEventComment:', e);
        throw new Error('failed');
      });
  }

  createEventInterestInvite({ id }: { id: string }): Promise<IApiResponse> {
    return eventApi
      .createEventInterestInvite(id)
      .then(res => {
        try {
          return parseResultInviteInterest(res);
        } catch (e) {
          console.error('ERROR: eventService/createEventInterestInvite:', res);
          return { success: false, message: 'Error occurred while processing the request' };
        }
      })
      .catch(e => {
        console.warn('ERROR: eventService/createEventInterestInvite:', e);
        return { success: false, message: 'Cannot invite interest' };
      });
  }

  patchDeleteEvent(params: { eventId: string; clubId?: any }): Promise<IApiResponse> {
    return eventApi.patchDeleteEvent(params).then(res => {
      try {
        return {
          success: res.success,
          data: res.data,
          message: res.message,
        };
      } catch (e) {
        console.log('ERROR: eventService/patchDeleteEvent:', res);
        return {
          success: false,
        };
      }
    });
  }

  patchDeleteInterest(params: IParamsRequest): Promise<IApiResponse> {
    return eventApi.patchDeleteInterest(params).then(res => {
      try {
        return {
          success: res.success,
          data: res.data,
          message: res.message,
        };
      } catch (e) {
        console.log('ERROR: eventService/patchDeleteInterest:', res);
      }
      return res;
    });
  }

  patchDeleteUserInterest(params: { ID: string; ListID: string[] }): Promise<IApiResponse> {
    return eventApi
      .patchDeleteUserInterest({
        ID: params.ID,
        ListID: params.ListID,
      })
      .then(res => {
        try {
          return {
            success: res.success,
            data: res.data,
            message: res.message,
          };
        } catch (e) {
          console.log('ERROR: eventService/patchDeleteUserInterest:', res);
        }
        return res;
      });
  }

  getEventCategory(): Promise<IApiResponse> {
    return eventApi
      .getEventCategory()
      .then(res => {
        if (res.success) {
          return {
            success: res.success,
            data: eventDetail.mappingEventCategories(res.data.items),
          };
        }
        console.log('ERROR: eventService/getEventCategory:', res.message);
        return res;
      })
      .catch(error => {
        console.log('ERROR: eventService/getEventCategory:', error);
        return { success: false, message: 'ERROR: eventService/getEventCategory' };
      });
  }

  getClubCategory(): Promise<IApiResponse> {
    return eventApi
      .getClubCategory()
      .then(res => {
        if (res.success) {
          return {
            success: res.success,
            data: eventDetail.mappingEventCategories(res.data.items),
          };
        }
        console.log('ERROR: eventService/getClubCategory:', res.message);
        return res;
      })
      .catch(error => {
        console.log('ERROR: eventService/getClubCategory:', error);
        return { success: false, message: 'ERROR: eventService/getClubCategory' };
      });
  }

  getEventPopularCount(googleMapPlaceID: string): Promise<IApiResponse> {
    const params = googleMapPlaceID ? { GoogleMapPlaceID: googleMapPlaceID } : {};
    return eventApi
      .getEventPopularCount(params)
      .then(res => {
        if (res.success) {
          return {
            success: res.success,
            data: eventDetail.mappingEventPopularCounts(res.data.items, googleMapPlaceID),
          };
        }
        console.log('ERROR: eventService/getEventPopularCount:', res.message);
        return res;
      })
      .catch(error => {
        console.log('ERROR: eventService/getEventPopularCount:', error);
        return { success: false, message: 'ERROR: eventService/getEventPopularCount' };
      });
  }

  getClubCount(googleMapPlaceID: string): Promise<IApiResponse> {
    const params = googleMapPlaceID ? { GoogleMapPlaceID: googleMapPlaceID } : {};
    return eventApi
      .getClubCount(params)
      .then(res => {
        if (res.success) {
          return {
            success: res.success,
            data: eventDetail.mappingEventPopularCounts(res.data.items, googleMapPlaceID),
          };
        }
        console.log('ERROR: eventService/getClubCount:', res.message);
        return res;
      })
      .catch(error => {
        console.log('ERROR: eventService/getClubCount:', error);
        return { success: false, message: 'ERROR: eventService/getClubCount' };
      });
  }

  patchUpdateMyEvent(params: IParamsRequest, clubId?: any): Promise<IApiResponse> {
    return eventApi.patchUpdateMyEvent(params, clubId).then(res => {
      try {
        return {
          success: res.success,
          data: res.data,
          message: res.message,
        };
      } catch (e) {
        console.log('ERROR: eventService/patchUpdateMyEvent:', res);
      }
      return res;
    });
  }

  getTimezone(): Promise<IApiResponse> {
    return eventApi.getTimezone().then(res => {
      try {
        return {
          success: res.success,
          data: res.data && timezone.mappingObjectListTimezone(res.data.items),
          message: res.message,
        };
      } catch (e) {
        console.log('ERROR: eventService/getTimezone:', res);
      }
      return res;
    });
  }

  getBanner(): Promise<IApiResponse> {
    return eventApi.getBanner().then(res => {
      try {
        return {
          success: res.success,
          data: res.data && eventBanner.mappingObject(res.data.items),
          message: res.message,
        };
      } catch (e) {
        console.log('ERROR: eventService/getBanner:', res);
      }
      return res;
    });
  }

  uploadOwnBanner(params: any): Promise<IApiResponse> {
    return eventApi.uploadOwnBanner(params).then(res => {
      try {
        return {
          success: res.success,
          data: res.data && eventBanner.mappingObjectBanner(res.data),
          message: res.message,
        };
      } catch (e) {
        console.log('ERROR: eventService/uploadOwnBanner:', res);
      }
      return res;
    });
  }

  getClubDetail(id: number): Promise<IApiResponse> {
    return eventApi.getClubDetail({ id }).then(res => {
      try {
        return {
          success: res.success,
          data: res.data && clubDetail.mappingObject(res.data),
          message: res.message,
        };
      } catch (e) {
        console.log('ERROR: eventService/getClubDetail:', res);
        return { success: false, message: 'ERROR: eventService/getClubDetail' };
      }
    });
  }

  getClubEvents(params: IParamsRequest): Promise<IApiResponse> {
    return eventApi.getClubEvents(params).then(res => {
      try {
        return {
          success: res.success,
          data: res.data && clubEvents.mappingObject(res.data),
          message: res.message,
        };
      } catch (e) {
        console.log('ERROR: eventService/getClubEvents:', res);
        return { success: false, message: 'ERROR: eventService/getClubEvents' };
      }
    });
  }

  patchUserEventInterestTicket(params: IParamsRequest) {
    return eventApi
      .patchUserEventInterestTicket({
        EventID: params.eventId,
        InterestID: params.interestId,
        IsEnabled: params.hasTicketAccess,
      })
      .then(res => {
        try {
          return res;
        } catch (e) {
          console.log('ERROR: eventService.patchUserEventInterestTicket');
        }
      });
  }
  patchUserEventInterestGroupChat(params: IParamsRequest) {
    return eventApi
      .patchUserEventInterestGroupChat({
        EventID: params.eventId,
        InterestID: params.interestId,
        IsEnabled: params.hasGroupChatAccess,
      })
      .then(res => {
        try {
          return res;
        } catch (e) {
          console.log('ERROR: eventService.patchUserEventInterestGroupChat');
        }
      });
  }

  deleteAllUserEventInterestGroupChat(eventId: string) {
    return eventApi.deleteAllUserEventInterestGroupChat(eventId).then(res => {
      try {
        return res;
      } catch (e) {
        console.log('ERROR: eventService.deleteAllUserEventInterestGroupChat');
      }
    });
  }

  postCreateGroupChat(params: IParamsRequest) {
    return eventApi.postCreateGroupChat(params).then(res => {
      try {
        return res;
      } catch (e) {
        console.log('ERROR: eventService.postCreateGroupChat:', e);
      }
    });
  }

  getSearchGroupChat(params: IParamsRequest) {
    return eventApi.getSearchGroupChat(params).then(res => {
      try {
        return {
          success: res.success,
          data: res.data && res.data.items,
          message: res.message,
        };
      } catch (e) {
        console.log('ERROR: eventService.getSearchGroupChat:', e);
      }
    });
  }

  patchUpdateGroupChat(params: IParamsRequest) {
    return eventApi.patchUpdateGroupChat(params).then(res => {
      try {
        return res;
      } catch (e) {
        console.log('ERROR: eventService.patchUpdateGroupChat:', e);
      }
    });
  }

  postAddAMemberFromGroupChat(params: IParamsRequest) {
    return eventApi.postAddAMemberFromGroupChat(params).then(res => {
      try {
        return res;
      } catch (e) {
        console.log('ERROR: eventService.postAddAMemberFromGroupChat:', e);
      }
    });
  }

  postRemoveAMemberFromGroupChat(params: IParamsRequest) {
    return eventApi.postRemoveAMemberFromGroupChat(params).then(res => {
      try {
        return res;
      } catch (e) {
        console.log('ERROR: eventService.postRemoveAMemberFromGroupChat:', e);
      }
    });
  }

  postEndGroupChat(params: IParamsRequest) {
    return eventApi.postEndGroupChat(params).then(res => {
      try {
        return res;
      } catch (e) {
        console.log('ERROR: eventService.postEndGroupChat:', e);
      }
    });
  }

  postLeaveGroupChat(params: IParamsRequest) {
    return eventApi.postLeaveGroupChat(params).then(res => {
      try {
        return res;
      } catch (e) {
        console.log('ERROR: eventService.postLeaveGroupChat:', e);
      }
    });
  }

  getPrivateGroupChat(params: IParamsRequest) {
    return eventApi.getPrivateGroupChat(params).then(res => {
      try {
        return res;
      } catch (e) {
        console.log('ERROR: eventService.getPrivateGroupChat', e);
      }
    });
  }

  postAcceptRules(params: IParamsRequest) {
    return eventApi.postAcceptRules(params).then(res => {
      try {
        return res;
      } catch (e) {
        console.log('ERROR: eventService.postAcceptRules', e);
      }
    });
  }

  deleteEventInterestByOwner(params: IParamsRequest) {
    return eventApi.deleteEventInterestByOwner(params).then(res => {
      try {
        return res;
      } catch (e) {
        console.log('ERROR eventService.deleteEventInterestByOwner', e);
      }
    });
  }

  postSearchUserEventInterests(params: IParamsRequest) {
    return eventApi.postSearchUserEventInterests(params).then(res => {
      try {
        if (res.success) {
          return {
            success: res.success,
            data: eventDetail.mappingObjectsEventInterest(res.data?.Data),
            total: res.data?.Total,
          };
        }
        return res;
      } catch (e) {
        console.log('ERROR eventService.postSearchUserEventInterests', e);
      }
    });
  }

  postCreateEventVideo(params: IParamsRequest) {
    return eventApi.postCreateEventVideo(params).then(res => {
      try {
        if (res.success) {
          return {
            success: res.success,
            data: mappingVideoFile(res.data?.Video),
          };
        }
      } catch (e) {
        console.log('ERROR eventService.postCreateEventVideo', e);
      }
      return res;
    });
  }

  getSuggestedUsers(params: { eventId: string; pageSize?: number; page?: number; memberType?: number; ageMax?: number; ageMin?: number }) {
    return eventApi.getSuggestedUsers(params).then(res => {
      try {
        return {
          success: true,
          data: User.mappingObjectsCustomMemberSearch(res.data.Data || []),
          total: res.data?.PaginationInfo?.TotalItems || 0,
        };
      } catch (err) {
        console.log('error in eventService/getSuggestedUsers', err);
        return { success: false, data: [], message: err };
      }
    });
  }

  getUserClubEventSuggestedUsers(params: {
    eventId: string;
    pageSize?: number;
    page?: number;
    memberType?: number;
    ageMax?: number;
    ageMin?: number;
  }) {
    return eventApi.getUserClubEventSuggestedUsers(params).then(res => {
      try {
        return {
          success: true,
          data: User.mappingObjectsCustomMemberSearch(res.data.Data || []),
          total: res.data?.PaginationInfo?.TotalItems || 0,
        };
      } catch (err) {
        console.log('error in eventService/getUserClubEventSuggestedUsers', err);
        return { success: false, data: [], message: err };
      }
    });
  }
}

export default new EventService();

function parseResultInviteInterest(res: any) {
  const result = res?.data?.Result;
  let success: boolean;
  let message: string;
  switch (result) {
    case 'Failed':
      success = false;
      message = 'Error occurred while processing the request';
      break;
    case 'EventNotFound':
      success = false;
      message = 'The event associated with the group you are joining does not exist';
      break;
    case 'PastEvent':
      success = false;
      message = 'The event has been ended';
      break;
    case 'HasRegistered':
      success = true;
      message = '';
      break;
    case 'UserNotMatched':
      success = false;
      message = 'You do not match with the event associated with the group you are joining';
      break;
    case 'Success':
      success = true;
      message = '';
      break;
    default:
      success = false;
      message = 'Unknown result';
      break;
  }
  return { success, message };
}
